import React from 'react';
import {  MuiGrid, MuiTypography } from '../../../ui/MaterialUIComponents';

import lodash from 'lodash';
import en from 'date-fns/locale/en-US';
import format from 'date-fns/format';
import startOfDay from 'date-fns/startOfDay'
import addDays from 'date-fns/addDays';
import { startOfWeek } from "date-fns";
import Paper from '@material-ui/core/Paper';

class TimeHeaderComponent extends React.Component {
  render() {
    return (
        <MuiGrid style={{ display: 'flex', Direction: 'column', border: '1px solid lightgray',height: '72px'}} justify="flex-end">
        
                <MuiGrid style={{ zIndex: 100, position: 'relative'}} >
                  <MuiTypography variant="subtitle2"> {this.props.label}</MuiTypography>
                </MuiGrid>
            
        </MuiGrid>
      )
  }
}

export default TimeHeaderComponent;